import * as React from 'react';

import { Divider, Header, VStack } from '@rbilabs/universal-components';

import SanityBlockRenderer from 'components/sanity-block-renderer';
import { t } from 'state/intl/translations';

import { QuestIncentive } from './quest-incentive';
import { QuestSteps } from './quest-steps';
import { QuestTerms } from './quest-terms';
import { QuestStepsSectionWrapper } from './styled';
import { IQuestDetailContentViewProps } from './types';

export const QuestDrawerContent = ({
  cmsQuestDetail,
  cmsQuestDetailUI,
  onCloseDrawer,
}: IQuestDetailContentViewProps) => {
  const { howToRedeem } = cmsQuestDetail;
  const howToRedeemSanityContent = howToRedeem?.localeRaw;

  return (
    <VStack space="$6">
      <QuestStepsSectionWrapper>
        <Header margin={0} variant="headerThree">
          {t('howItWorks')}
        </Header>
        <SanityBlockRenderer content={howToRedeemSanityContent} />
        <QuestSteps
          cmsQuestRequirementById={cmsQuestDetail.requirementByCmsId}
          cmsQuestDetail={cmsQuestDetail}
          cmsQuestDetailUI={cmsQuestDetailUI}
          onCloseDrawer={onCloseDrawer}
        />
      </QuestStepsSectionWrapper>
      <QuestIncentive
        cmsIncentive={cmsQuestDetail.incentive}
        cmsQuestDetail={cmsQuestDetail}
        onCloseDrawer={onCloseDrawer}
      />
      <Divider />
      <QuestTerms cmsQuestTerms={cmsQuestDetail.moreInfo} />
    </VStack>
  );
};
